import React, { Component, Fragment } from "react";

import { Metric } from "./../Utils/Utils.js";
import Heading from "./../Elements/Heading";

class LastWeekViewing extends Component {
  render() {
    const { data } = this.props;

    return (
      <Fragment>
        <div className="mt-2 row d-flex align-items-end">
          {data.unique_viewers ? (
            <div className="col-6 col-md-3">
              <Heading size={6} className={"mb-1"}>
                Unique Viewers
              </Heading>
              <Metric {...data.unique_viewers} size={"md"} />
            </div>
          ) : null}

          {data.views ? (
            <div className="mb-3 col-6 col-md-3 mb-md-0">
              <Heading size={6} className={"mb-1"}>
                Views
              </Heading>
              <Metric {...data.views} size={"md"} />
            </div>
          ) : null}

          {data.minutes_watched ? (
            <div className="mb-3 col-6 col-md-3 mb-md-0">
              <Heading size={6} className={"mb-1"}>
                Min Watched
              </Heading>
              <Metric {...data.minutes_watched} size={"md"} />
            </div>
          ) : null}
        </div>
      </Fragment>
    );
  }
}

export default LastWeekViewing;
